import { createContext } from "react";

export const TogglePages = createContext({ state: null, dispatch: null });